import { Box, Card, CircularProgress, Typography } from '@mui/material'
import { STARTSurveyDisplay } from '../../../../customComponents/survey/STARTSurveyDisplay'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { type SurveySchema, SurveyType } from '../../../../../models/SurveySchema'
import { styles } from './MidYear.styles'
import { useProgressReportAccess } from '../../../../../hooks/use-progressReportAccess'
import { useEffect, useState } from 'react'
import { handleApiResponse } from '../../../../../utils/apiHelpers'
import { GetSurvey } from '../../../../../services/SurveyService'
import { MidYearSummary } from './Summary/MidYearSummary'

export function MidYear (): JSX.Element {
  const { rcnId, planId, planOrgId } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const annualPlanId = planId != null ? Number(planId) : 0
  const planOrgIdNum = Number(planOrgId)
  const rcnIdNum = Number(rcnId)

  const { isLoading: isLoadingAccess, surveyType } = useProgressReportAccess({
    annualPlanId,
    planOrgId: planOrgIdNum,
    rcnId: rcnIdNum,
    surveyTypeFromState: location.state?.surveyType,
    redirectPath: '..'
  })

  const [survey, setSurvey] = useState<SurveySchema | undefined>(undefined)
  const [loadingSurvey, setLoadingSurvey] = useState(true)

  useEffect(() => {
    const fetchSurvey = async (): Promise<void> => {
      if (surveyType == null) return
      const res = await handleApiResponse(GetSurvey(surveyType, planOrgIdNum))
      setSurvey(res ?? undefined)
      setLoadingSurvey(false)
    }

    void fetchSurvey()
  }, [surveyType, planOrgIdNum])

  if (isLoadingAccess || loadingSurvey || surveyType == null) {
    return <div><CircularProgress /></div>
  }

  const isRcn = surveyType === SurveyType.RCNMidYear
  const schemaId = surveyType

  const navigateToSummary = (): void => {
    setSurvey(prev => prev != null ? { ...prev, isSubmitted: true } : undefined)
  }

  const handleExit = (): void => {
    navigate(`../Organization/${String(planOrgId)}`)
  }

  if (survey?.isSubmitted === true) {
    return <MidYearSummary initialSurvey={survey} />
  }

  return (
    <Card sx={styles.card} data-testid='midYearReportCard'>

      <Box sx={styles.content}>
        <Box sx={styles.header}>
          <Typography variant='h1'>Progress Reports</Typography>
        </Box>

        <Typography variant='body1'>
          Share information about your progress toward your Implementation Plan with START at Mid-Year and End of Year by completing the Progress Reports.
        </Typography>

        <Box sx={styles.surveyContainer}>
          <STARTSurveyDisplay
            annualPlanId={annualPlanId}
            surveyType={schemaId}
            title={isRcn ? 'RCN Mid-Year' : 'ISD Progress on Contract Goals'}
            navigateToSummary={navigateToSummary}
            planOrgId={Number(planOrgId)}
            initialSurvey={survey}
            setSurvey={setSurvey}
            onExit={handleExit}
          />
        </Box>
      </Box>
    </Card>
  )
}
